import { useAtom, useSetAtom } from 'jotai';
import { papersAtom, userAtom } from '../atom'; // Ensure the correct path to atoms
import { GoogleAuthProvider, createUserWithEmailAndPassword, getAuth, sendEmailVerification, sendPasswordResetEmail, signInWithEmailAndPassword, signInWithPopup, signOut, updateProfile } from "firebase/auth";
import { auth, db, provider } from "../firebase";
import { collection, doc, getDoc, getDocs, setDoc, Timestamp, updateDoc } from "firebase/firestore";
import { message } from "antd";
import { useNavigate } from 'react-router-dom';
import { Exception } from 'sass';



export const useSigningMethods = () => {
  const setUser = useSetAtom(userAtom);
  const auth = getAuth()
  const nav = useNavigate()

  const handleMailSignUp = async(email,password,name)=>{
    createUserWithEmailAndPassword(auth, email, password)
    .then(async(userCredential) => {
      // Signed up 
      const user = userCredential.user;

      // Send verification email
      sendEmailVerification(user)
        .then(() => {
          // message.success("Email Verification has been sent!!")
          console.log("Verification email sent.");
        })
        .catch((error) => {
          console.error("Error sending verification email:", error);
        });

        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);
        const newDataUserRef = doc(db, 'global', "newDataCheck");

  
        if (!docSnap.exists()) {
          await setDoc(doc(db, "users", user.uid), {
            uid: user.uid,
            displayName: name,
            email: user.email,
          });
        }
        updateProfile(user, {
          displayName: name
        }).then(() => {
          console.log("User display name updated successfully");
        }).catch((error) => {
          console.error("Error updating user display name:", error);
        });
      // ...
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      message.error(errorMessage)
      console.error(error);
      // ..
    });
  }

  const handleMailSignIn = async (email,password) => {
    try{
      signInWithEmailAndPassword(auth, email, password)
      .then(async(userCredential) => {
        // Signed in
        const user = userCredential.user;
    
        if (user.emailVerified) {
          const docRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(docRef);
    
          user["data"] = docSnap.data()
          setUser(user)
          if(user){
            nav("/home")
          }
          message.success("Signed in")
        } else {
          message.error("Please verify email to sign in")
          auth.signOut();
          setUser(null)
        }
        return true
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        message.error(errorMessage)
        return false
        console.error(error);
      });
    }catch(err){
      message.error(err.message)
      console.error(String(err))
      return false
    }
  }

  const sendResetEmail = (email) => {
    sendPasswordResetEmail(auth, email)
      .then(() => {
        message.success("Password Reset Link sent")
        console.log("Password reset email sent successfully");
      })
      .catch((error) => {
        message.error(error?.message || "Error Sending Reset Mail")
        console.error("Error sending password reset email:", error);
      });
  };

  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential.accessToken;
      const user = result.user;

      const docRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        await setDoc(doc(db, "users", user.uid), {
          uid: user.uid,
          displayName: user.displayName,
          email: user.email,
        });
        message.success("Welcome " + user.displayName);
      } else {
        message.success("Welcome Back " + user.displayName);
      }

      setUser(user); // Update the user atom with the signed-in user

    } catch (error) {
      console.log("Error:" + error);
      message.error(error.message);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUser(null); // Update the user atom to null
      message.success("Logged Out");
    } catch (error) {
      message.warning('Error logging out:', error.message);
    }
  };

  return {
    sendResetEmail,
    handleMailSignUp,
    handleGoogleSignIn,
    handleMailSignIn,
    handleLogout,
  };
};

export const useDataFetching = () => {

  const [papersData, setPapersData] = useAtom(papersAtom);
  
  const getData = async() => {
    const storedData = localStorage.getItem('firebaseData');
    const lastDataFetching = new Date(JSON.parse(localStorage.getItem('lastDataFetched'))) || null
    let retrievalCounter = parseInt(localStorage.getItem('retrievalCounter')) || 0;

    
    
    if (storedData !== null && retrievalCounter < 4) { // get data from local storage at most 5 times so that update data should also be displayed
      const parsedData = JSON.parse(storedData);
      setPapersData(parsedData);
      retrievalCounter++
      localStorage.setItem('retrievalCounter', retrievalCounter.toString())
      return parsedData;
    } else {
      if (retrievalCounter >= 4){
        const parsedData = JSON.parse(storedData);
        setPapersData(parsedData);
        // message.info("CHECKNING RETREIVELA")
        const docRef = doc(db, "global", "newDataCheck");
        const content = await getDoc(docRef);
        const updatedFirebaseDate = content.data()
        if (updatedFirebaseDate.lastUpdatedDate && updatedFirebaseDate.lastUpdatedDate.seconds !== undefined) {
          const lastUpdatedDate = new Date(
            updatedFirebaseDate.lastUpdatedDate.seconds * 1000 + 
            updatedFirebaseDate.lastUpdatedDate.nanoseconds / 1000000
          );
          if (!lastDataFetching || lastDataFetching < lastUpdatedDate) {
            // message.info("GETTING DATA")
            const allData = [];
            const querySnapshot = await getDocs(collection(db, "data"));
            
            querySnapshot.forEach((doc) => {
              allData.push(doc.data())
            });
            setPapersData(allData);
            localStorage.setItem('firebaseData', JSON.stringify(allData));
            const currentDate = new Date()
            localStorage.setItem('lastDataFetched',JSON.stringify(currentDate))
            retrievalCounter = 0;
            localStorage.setItem('retrievalCounter', retrievalCounter.toString())
            return allData
          }
        }
        retrievalCounter = 0;
        localStorage.setItem('retrievalCounter', retrievalCounter.toString())
        return parsedData
      }else{
        message.info("Updating Data")
        const allData = [];
        const querySnapshot = await getDocs(collection(db, "data"));
        
        querySnapshot.forEach((doc) => {
          allData.push(doc.data())
        });
        setPapersData(allData);
        localStorage.setItem('firebaseData', JSON.stringify(allData));
        const currentDate = new Date()
        localStorage.setItem('lastDataFetched',JSON.stringify(currentDate))
        retrievalCounter = 0;
        localStorage.setItem('retrievalCounter', retrievalCounter.toString())
        return allData
      }
    }
    // setLoading(false);
  }

  return {
    getData
  }
}

export const getFormattedDate = () => {
  const currentDate = new Date();

  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  const day = currentDate.getDate().toString().padStart(2, '0');
  const hours = currentDate.getHours().toString().padStart(2, '0');
  const minutes = currentDate.getMinutes().toString().padStart(2, '0');
  const seconds = currentDate.getSeconds().toString().padStart(2, '0');

  const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

  return formattedDateTime;
}

export const updateFirebaseGlobalDataFetchingDate = async() => {
  const docRef = doc(db, "global", "newDataCheck");

  try {
    const currentTimestamp = Date.now();
    const currentDate = new Date(currentTimestamp);

    await updateDoc(docRef, {
      "lastUpdatedDate": Timestamp.fromDate(currentDate)
    });

    console.log("Document successfully updated with current timestamp!");

  } catch (e) {
    console.error("Error updating document: ", e);
  }
}
